import React, { useState, useEffect } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import { useDispatch, useSelector } from 'react-redux';
import {getStudyData} from '../../../Redux/actions/actions';
import axios from "../../../axios-interceptor";
import { base_url } from "../../../utilities";
import PopUpModal from "../../ReusableComp/PopUpModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import Loader from '../../ReusableComp/Loader';

const PMSAdminEditQR = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const studyDataReceived = location && location.state && location.state.data;
    const[mapedStudy,setMapedStudy] =useState([])

    useEffect(() => {
        if (!localStorage.getItem("login_user_name")) {
            navigate("/");
        }
        const convertedData = studyDataReceived?.qr_studies.map(item => ({
            value: item.study_id,
            label: `${item.study_name}`
          }));
          setMapedStudy(convertedData)

    }, []);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const studyMasterData = useSelector((state) => (state.studyData));
    const studyData = studyMasterData?.filter(item => !mapedStudy.some(i => item.study_id === i.value)); 
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [studyIds, setStudyIds] = useState([]);
    const [studyInfo, setStudyInfo] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getStudyData());
    }, [dispatch]);
    const sampar = [];

    const handleChange = (selected) => {
        
        selected.map((item) => { sampar.push(item.value)})
        setSelectedOptions(selected);
        setStudyIds(sampar);
        
        const filteredJsonList = studyData?.filter((json) => sampar.includes(json.study_id));
        
        setStudyInfo(filteredJsonList)
    };


    const handleClosePopup = () => {
        setOpen(false);
        navigate("/qrlist")
        window.location.reload();
    };


    const createNewPI = () => {
        const mapedStudyIds =mapedStudy.map(i=>(i.value))
        let qr_object = {
            qr_id: studyDataReceived?.qr_id,
            study_ids: [...studyIds , ...mapedStudyIds]
            }
        setLoading(true);
        axios
            .post(base_url + "quality-reviewer/update_qr_studies", qr_object)
            .then((res) => {
                setLoading(false);
                if (res.data.data.errors) {
                    if (res.data.data.errors[0].message === "email must be unique") {
                        toast.error('The user has already been created with the given email.', {
                            toastId: 1
                        })
                    }
                }
                else {
                    setOpen(true);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    
    const viewProfile = () => {
       navigate("/qrlist")
    }
    

    const [regStep, setRegStep] = useState(1);

    const registrationSteps = [
        
        {
            stepTitle: "1. Quality Reviewer Studies",
            description: "Study Information"
        },

    ];
    
    
    
    return (
        <>
        
      
        <div>
            <NavigationBar studyDropdwn={true} title={"Quality Reviewer"} />
            <div className='main_body registration_steps_main'>
                <div className='row flex-nowrap'>
                    <div className="col-lg-3 pi_left_content_main" >
                        <div className='lableSteps'>
                            <span >Edit Quality Reviewer Studies</span>
                        </div>

                        <div className='pmsaddpireg'>
                            {registrationSteps?.map((step, index) => {
                                return (
                                    <div className={`my-div ${regStep === index + 1 ? 'registration_steps_selected' : 'registration_steps'}`} key={index}>
                                        <span>{step.stepTitle}</span>
                                        <span className='registration_description'>{step.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="col">
                        <div className='lableContent'>
                            <span >{registrationSteps[regStep - 1].stepTitle}</span>
                            <span >{regStep} of 1</span>
                        </div>

                        
                        {/* Study and Dose Details */}
                        {regStep === 1 &&
                            <div className='piRegPrev'>
                                <div>
                                    <div style={{ margin: '32px', display: "flex", flexDirection: "column", textAlign: "start" }} className='remove_cross '>
                                        <label className='mb-3'>Mapped Study</label>
                                        {mapedStudy.length >= 1 ? (
                                            <ul>
                                                {mapedStudy.map((item) => (
                                                <li key={item.value}>{item.label}</li>
                                                ))}
                                            </ul>
                                            ) : (
                                            <p>No mapped study</p>
                                            )} 
                                    </div>
                                </div>
                                <div style={{ margin: '32px', display: "flex", flexDirection: "column", textAlign: "start" }}>
                                    <label htmlFor="piStudy">Select Study<span className="text-danger">*</span></label>
                                    <Select
                                        id="piStudy"
                                        isMulti
                                        options={studyData?.map((item) => ({
                                            value: item.study_id,
                                            label: `${item.study_name}`,
                                        }))}
                                        value={selectedOptions}
                                        onChange={handleChange}
                                        placeholder="Select Study from the options"
                                    />
                                </div>
                            </div>
                        }

                        <div className='registrationStepsFooter'>
                            {regStep === 1 &&
                                <button className="white_btn px-3" onClick={() => viewProfile()}  >Close</button>
                            }
                            {regStep === 1 &&
                                 <button className="orange_btn" onClick={() => createNewPI()}
                                 disabled={!(studyIds.length !== 0)}
                             >Update</button>
                            }
                
                        </div>

                    </div>
                </div>

            </div>
            <PopUpModal
                handleClose={handleClosePopup}
                open={open}
                title={"Success!"}
                msg={"Quality Reviewer studies has been updated!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={viewProfile}
            />
        </div>

            {loading && <Loader />}
            </>
    );
};

export default PMSAdminEditQR;   